import React from "react";
import { Box } from "@chakra-ui/react";
import { AvatarBox } from "@root/components/styles";

interface UserAvatarProps {
  avatar?: string;
  fullName?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ avatar, fullName }) => {
  return (
    <Box {...AvatarBox}>
      {avatar ? (
        <img src={avatar} alt={fullName || "User"} width="100%" height="100%" />
      ) : (
        <Box
          width="100%"
          height="100%"
          bg="#E4EBF0"
          borderRadius="50%"
          display="flex"
          alignItems="center"
          justifyContent="center"
          fontSize="14px"
          fontWeight="600"
          color="#6B7280"
        >
          {fullName?.charAt(0)?.toUpperCase() || "U"}
        </Box>
      )}
    </Box>
  );
};

export default UserAvatar;
